export default __webpack_public_path__ + "images/it-290f2fec799fabdf2a85be3d2a2f9977.svg";